import React from 'react';
import PropTypes from 'prop-types';

import TruckIcon from '~/components/TruckIcon';

import setTruckColor from './functions/setTruckColor';
import fixBadWords from './functions/fixBadWords';

import {
    Panel,
    PanelBody,
    IconContainer,
    TrackingContent,
    PanelText,
} from './styles';

function TrackingCard({ historico }) {
    return (
        <Panel>
            <PanelBody color={setTruckColor(historico.descricao)}>
                <IconContainer>
                    <TruckIcon color={setTruckColor(historico.descricao)} />
                </IconContainer>

                <TrackingContent>
                    <PanelText>
                        <span
                            className="local-historico-rastreio"
                            style={{
                                color: setTruckColor(historico.descricao),
                            }}
                        >
                            {fixBadWords(historico.descricao)}
                        </span>
                        <span className="data-historico-rastreio">
                            {historico.data}
                        </span>
                    </PanelText>

                    <PanelText>
                        {!historico.destino ? (
                            <p className="destino-historico-rastreio">
                                <strong>Em</strong> {historico.local} -{' '}
                                {historico.cidade}
                            </p>
                        ) : (
                            <p className="destino-historico-rastreio">
                                <strong>De</strong> {historico.local} -{' '}
                                {historico.cidade}
                            </p>
                        )}
                        {historico.destino ? (
                            <p className="destino-historico-rastreio">
                                <strong>Para</strong> {historico.destino.local}{' '}
                                - {historico.destino.cidade}
                            </p>
                        ) : (
                            ''
                        )}
                    </PanelText>
                </TrackingContent>
            </PanelBody>
        </Panel>
    );
}

TrackingCard.propTypes = {
    historico: PropTypes.shape({
        cidade: PropTypes.string,
        codigo: PropTypes.string,
        data: PropTypes.string,
        dataHora: PropTypes.string,
        descricao: PropTypes.string,
        eventoFinal: PropTypes.bool,
        hora: PropTypes.string,
        local: PropTypes.string,
        status: PropTypes.number,
        tipo: PropTypes.string,
        uf: PropTypes.string,
        destino: PropTypes.shape({
            bairro: PropTypes.string,
            cidade: PropTypes.string,
            codigo: PropTypes.string,
            local: PropTypes.string,
            uf: PropTypes.string,
        }),
    }).isRequired,
};

export default TrackingCard;
